//utils
import './utils/plugins'
import './utils/translations'
import './utils/global-components'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {patchLocalizedRouting, syncLocaleFromUrl} from './utils/translations'
import {isAbortedRequest} from './utils/https'
import {registerApp} from './utils/app-handle'

// Імпортуємо трекери для Google Analytics
import PurchaseTracker from './utils/purchaseTracker'

// Тестовий файл видалено

Vue.config.productionTip = false

// Трекеры аналитики живут вне компонентов и ищут стор и роутер снаружи.
// Раньше они делали это через window.Vue.prototype — конструкцию, которая
// в этом проекте никогда не работала (подробности в utils/app-handle.js).
registerApp({store, router})

window.addEventListener('unhandledrejection', (event) => {
    const reason = event && event.reason ? event.reason : null;
    const status = reason && reason.status ? reason.status : null;
    const message = reason && reason.message ? reason.message : '';

    if (message === 'Request aborted') {
        event.preventDefault();
        return;
    }

    // 404/500 already handled centrally in axios interceptor via UX redirect.
    if (status === 404 || status === 500) {
        event.preventDefault();
    }
});

// set auth status
if (localStorage.getItem('user_token')) {
    store.state.auth.isAuthenticated = true
}

const app = new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
        document.dispatchEvent(new Event('render-event'))
        
        // Ініціалізуємо глобальний трекер покупок
        if (!window.purchaseTracker) {
            window.purchaseTracker = new PurchaseTracker();
            console.log('🛒 Глобальний Purchase трекер ініціалізовано');
        }
    }
});

Vue.initI18nManager()
    .catch((error) => {
        if (!isAbortedRequest(error)) {
            console.error('Failed to initialize localization', error);
        }
    })
    .finally(async () => {
        patchLocalizedRouting(router, store);

        try {
            await syncLocaleFromUrl(store);
        } catch (error) {
            if (!isAbortedRequest(error)) {
                console.error('Failed to sync locale from URL', error);
            }
        }

        if (!app._isMounted) {
            app.$mount('#app');
        }
    });

// const eventHub = new Vue()


Vue.mixin({
    data: function () {
        return {
            // eventHub: eventHub
        }
    }
})
